import { Navigate } from 'react-router-dom';
import { getIntroPath } from '../routing/app-router-paths';

export default function NotFoundPage() {
  return (
    <Navigate state={{ from: window.location.href }} to={getIntroPath()} />
  );
}
